module.exports = __webpack_public_path__ + "static/email-template-trial-ended-elephanty-90bb46f7ce7650264dcfd1e3cb7a40fd.png";